export const BuildInfo = {timestamp:1769626881000}
